import RichText from '@eneco/components/RichText/RichText';
import { InputText } from '@eneco/sparky';
import type { Fields } from '@sitecore/types/GenericFormInputField';
import { useFormContext, useFormState } from 'react-hook-form';
import * as yup from 'yup';

import { FormValues, GenericFormFC, GenericFormInputProps } from '../../util';

const NAME_FALLBACK = 'inputFormField';

function isGenericFormInputField(field: Fields) {
  return field?.genericInputField !== undefined;
}

const GenericFormInputField: GenericFormFC<GenericFormInputProps> = ({ fields }) => {
  const { register } = useFormContext();
  const { errors } = useFormState<FormValues>();

  if (!isGenericFormInputField(fields)) {
    return null;
  }

  const { hint, label, placeholder } = fields?.genericInputField?.value ?? {};
  const name = fields?.genericInputField?.value?.name || NAME_FALLBACK;

  return (
    <InputText
      error={errors?.[name]?.message}
      hint={<RichText html={hint}></RichText>}
      label={label}
      placeholder={placeholder}
      {...register(name)}
    />
  );
};

GenericFormInputField.yupValidationScheme = (fields: Fields) => {
  const { requiredMessage } = fields?.genericInputField?.value ?? {};
  const name = fields?.genericInputField?.value?.name || NAME_FALLBACK;

  return { [name]: requiredMessage ? yup.string().required(requiredMessage) : yup.string() };
};

export default GenericFormInputField;
